// extracted by mini-css-extract-plugin
var _1 = "styles-module__deleteModalBody___hkXKx";
export { _1 as "deleteModalBody" }
